import type {EntryPoint} from 'react-relay'
import {getRequest} from 'relay-runtime'

import {makeResource} from '../../../../../../utils/makeResource'

import type {PipelinesSidebarContentComponent} from './PipelinesSidebarContent'
import {query} from './PipelinesSidebarContent.queries'

export const PipelinesSidebarContentEntryPoint: EntryPoint<PipelinesSidebarContentComponent> = {
  root: makeResource(
    'PipelinesSidebarContent',
    () => import(/* webpackChunkName: "PipelinesSidebarContent" */ './PipelinesSidebarContent'),
  ),
  getPreloadProps: () => ({
    queries: {
      main: {
        parameters: getRequest(query),
        variables: {},
        options: {networkCacheConfig: {metadata: {essential: true}}},
      },
    },
  }),
}
